<template>
    <div id="app" :class="{'pt88':top_show}">
        <top-fixed v-if="top_show" :isback.sync="top_isback" :title.sync="top_title" :showRight.sync="rightBtn"></top-fixed>
        <!--未关注-->
        <div class="top-prompt" @click="showQRcode" v-show="is_subscribe == 0">
            <i class="pull-left ionicons ion-ios-information mr10"></i>
            <span class="pull-left">您还没关注公众号，快来关注我吧！</span>
            <button>关注</button>
        </div>
        <router-view :class="{'none-subscribe': is_subscribe == 0}" :foot_type="foot_type"></router-view>

        <!--弹出关注二维码-->
        <div class="wrap" v-if="wrap" @touchmove.prevent>
            <div class="QR-code">
                <i class="close ionicons ion-ios-close-outline" @click="showQRcode"></i>
                <h1>
                    <span>悦小妖商城</span>
                </h1>
                <div>
                    <img :src="img_path" alt />
                </div>

                <p>长按二维码，关注我们</p>
            </div>
        </div>

        <!-- 右边悬浮 -->
        <div
            i="navigation"
            class="h-navi"
            id="moveDiv"
            v-if="show_kefu"
            @mousedown="down()"
            @touchstart.prevent="down()"
            @mousemove="move()"
            @touchmove.prevent="move()"
            @mouseup="end()"
            @touchend.prevent="end()"
        >
            <a class="h-service m-size" @click="toKefu()"></a>
        </div>

        <!-- 弹窗 -->
        <div class="base-props-box" v-show="show_alert">
            <!-- <div class="props-box"> -->
            <div class="props" @touchmove.prevent></div>
            <div class="alert-a" @touchmove.prevent>
                <div class="middle-center">
                    <p class="text-center">温馨提示</p>
                    <p>检测到您还未完善实名信息，为了更好的为您提供更多服务，请移步完善！</p>
                    <div class="div-btns clearfix">
                        <a class="pull-right" @click="toInfo()">前往完善</a>
                    </div>
                </div>
            </div>
        </div>

        <!-- 弹窗 -->
        <div class="base-props-box" v-show="show_prop">
            <div class="props"></div>
            <div class="alert-a">
                <div class="middle-center">
                    <p class="text-center">温馨提示</p>
                    <p>此常住地无需与身份证地址相同，请选择您从事商业活动和日常生活所在地</p>
                    <div class="div-btns clearfix">
                        <a class="pull-right" @click="toAddress()">前往设置</a>
                    </div>
                </div>
            </div>
        </div>

        <!-- 完善所属区域弹窗 -->
        <div class="base-props-box" v-show="show_area_prop">
            <div class="props" style="opacity: 0.8"></div>
            <div class="alert-a">
                <div class="middle-center">
                    <p class="text-center">温馨提示</p>
                    <p>因系统完善，需完善您的所属区域，请选择您的所属区域</p>
                    <div class="div-btns clearfix">
                        <a class="pull-right" @click="toUrl('/citySelect'), show_area_prop = false">选择</a>
                    </div>
                </div>
            </div>
        </div>

        <!-- 优惠券弹框 -->
        <div class="coupon" v-if="couponLists.length > 0">
            <div class="mask"></div>
            <div class="cou-box">
                <div class="coupon-item" v-for="(item,index) in couponLists" :key="index">
                    <div class="item-left">
                        <span>{{item.amount | toFixedPrice}}元</span>
                        <span>优惠券</span>
                    </div>
                    <div class="item-right">
                        <span>{{item.title}}</span>
                    </div>
                </div>
                <div class="top">
                    <div class="coupon-btn" @click="getCoupon()"></div>
                </div>
            </div>
        </div>

        <!-- 8月活动 -->
        <popup v-model="showAugActivity" class="augActivity" position="center">
            <!-- 补货返券弹窗 -->
            <div class="cont replenishment" v-if="showReplenishment">
                <div class="image">
                    <img src="~images/aug_activity/tc01.png" alt="tc01" />
                    <div class="btn" @click="goPath('/distribution/stock/list', { stock_status: 1 })"></div>
                </div>
            </div>
            <!-- 未用的产品券 -->
            <div class="cont unused_voucher" v-if="showUnusedVoucher">
                <div class="image">
                    <img src="~images/aug_activity/tc03.png" alt="tc03" />
                    <div class="amount">{{voucherAmount | toFixedPrice}}元</div>
                    <div class="btn" @click="goPath('/distribution/coupon/exchange')"></div>
                    <div class="date">{{voucherStartAt | setTimeTran('n月j日')}} - {{voucherEndAt | setTimeTran('n月j日')}}</div>
                </div>
            </div>
            <div class="close" :class="{'mt0': showUnusedVoucher}" @click="showAugActivity = false"></div>
        </popup>
    </div>
</template>

<script>
import Vue from 'vue';
import topFixed from 'components/Top_fixed.vue';
import jdCity from 'components/Jdcity.vue';
import { Popup } from 'mint-ui';
Vue.use(Popup.name, Popup);

export default {
    data() {
        return {
            foot_type: null,
            wrap: false /*显示关注二维码*/,
            is_subscribe: 1,
            is_dealer: 0,
            img_path: '',
            is_trditional: false,
            is_init: true,
            is_wxjs: true, //是否选择默认微信配置
            show_kefu: false, //是否显示客服
            kefu: {
                type: 0, //标识商品或订单(1商品，2订单。。。)
                id: 0 //对应的商品id或订单id
            },
            show_alert: false,
            areaShow: false,
            nationCode: {},
            city: [],
            show_prop: false,
            couponLists: [],

            top_title: null,
            top_isback: false,
            top_show: false,
            rightBtn: false,
            flags: false,
            position: {
                x: 0,
                y: 0
            },
            nx: '',
            ny: '',
            dx: '',
            dy: '',
            xPum: '',
            yPum: '',
            touchOrClick: true, //默认点击状态
            showAugActivity: false,
            showReplenishment: false,
            showUnusedVoucher: false,
            voucherAmount: 0,
            voucherStartAt: 0,
            voucherEndAt: 0,
            show_area_prop: false,
            types: 0
        };
    },
    created() {
        let that = this;

        window.HubBus = new tools.vue();
        window.HubBus.$on('footType', function(type) {
            that.foot_type = type;
        });
        window.HubBus.$on('popup', function(status, type = 0) {
            that.show_alert = status;
            that.types = type
        });
        window.HubBus.$on('title', function(text) {
            that.top_title = text;
            document.title = text;
        });
        window.HubBus.$on('wxConfig', function(type) {
            that.is_wxjs = type;
        });
        window.HubBus.$on('setKefu', function(obj) {
            if (!obj) {
                //离开页面后再次触发,不传参数,清除数据
                that.kefu = {
                    type: 0,
                    id: 0
                };
            } else {
                that.kefu = obj;
            }
        });
        tools.router.afterEach((to, from) => {
            //如果是ios
            if (app.device().ios && app.isWeChat()) {
                let isPageHide = false;
                window.addEventListener('pageshow', function() {
                    if (isPageHide) {
                        window.location.reload();
                    }
                });
                window.addEventListener('pagehide', function() {
                    isPageHide = true;
                });
            }
            setTimeout(() => {
                const loginData = JSON.parse(tools.cache.get('loginData'));
                if (loginData && loginData.is_user && to.path !== '/login') {
                    that.getDialogVisiable();
                }
            }, 300);
        });

        /*
         **混合 （请认真查看使用方法 https://vuefe.cn/v2/guide/mixins.html）
         **注意同名钩子函数将混合为一个数组，因此都将被调用。且先调用混合对象的钩子
         **
         */
        tools.vue.mixin({
            data() {
                return {
                    is_audit_register: 1, // 注册审核账号  隐藏部分功能
                    top_show: (app.device().ios && !app.isWeChat()) || false,
                    isIos: app.device().ios,
                    is_activate: 1, //是否激活， 1:激活，0：未激活（才需要传字段bind_phone）
                    is_can_bind_phone: 0,
                    level_id: 0,
                    loginData: {}
                };
            },
            mounted() {
                if (tools.cache.get('loginData')) {
                    this.loginData = JSON.parse(tools.cache.get('loginData'));
                    const loginData = JSON.parse(tools.cache.get('loginData'));
                    this.is_audit_register = loginData.is_audit_register;
                    this.is_activate = loginData.is_activate;
                    this.is_can_bind_phone = loginData.is_can_bind_phone;
                    this.level_id = loginData.level_id;
                    if (loginData.area_province_id) {
                        if (location.pathname != '/citySelect' && loginData.has_area_city == 0) {
                            this.show_area_prop = true;
                        }
                    }
                    if (loginData.is_can_scale === 1 && location.pathname !== '/scaleusercompinfo') {
                        tools.alert.info('温馨提示', '体脂秤用户需完善资料才能浏览商城，是否前往完善资料？', () => {
                            tools.router.replace('/scaleusercompinfo');
                        });
                    }
                }
            },
            /* 全局方法 */
            methods: {
                /* 默认图片过滤 */
                thumbnail: function(val, size) {
                    let img_size = '?x-oss-process=image/resize,w_' + size;
                    return !val ? app.defaultImg() : val + (!size ? '' : img_size);
                },
                toThumbnail: function(val, size) {
                    let img_size = '?x-oss-process=image/resize,w_' + size;
                    return !val ? '' : val + (!size ? '' : img_size);
                },
                /* 查看大图 */
                seeImg: function(imgUrl, arr) {
                    let imgArr = arr;
                    if (arr === undefined) {
                        imgArr = [imgUrl];
                    }
                    app.seeImg(imgUrl, imgArr);
                },
                /* 跳转 */
                toUrl: function(url, val) {
                    tools.router.push({
                        path: url,
                        query: val
                    });
                },
                /* 跳转 */
                toReplace: function(url, val) {
                    tools.router.replace({
                        path: url,
                        query: val
                    });
                },
                alertFunc: function(msg) {
                    tools.alert.message(msg);
                }
            },
            /* 全局过滤 */
            filters: {
                /* 默认图片过滤 */
                thumbnail: function(val, size) {
                    return !val ? app.defaultImg() : val + (!size ? '' : size);
                },
                /* 时间转换 */
                timeTran: function(value) {
                    return !value ? '-' : tools.date('Y-m-d H:i:s', value);
                },
                /* 自定时间格式转换 */
                setTimeTran: function(value, type) {
                    return parseInt(value) === 0 ? '-' : tools.date(type, value);
                },
                /* 价格转换--保留两位小数 */
                toFixedPrice: function(value) {
                    return value ? (parseInt(value) / 100).toFixed(2) : '0';
                },
                //价格转换(保留两位小数,不足补零,大数字3位数加一个逗号)
                priceFormat: function(val) {
                    //val是以分为单位
                    if (typeof val === 'undefined') {
                        return;
                    }
                    var val_str = '',
                        val_arr = [];
                    val_str = val.toString();
                    val_arr = val_str.split('');
                    //判断价格位数
                    if (val_arr.length <= 5) {
                        return (val / 100).toFixed(2);
                    } else {
                        val_arr.splice(val_arr.length - 2, 0, '.'); //添加小数点
                        for (var i = val_arr.length - 4, num = 1; i > 0; i--, num++) {
                            if (num == 3) {
                                val_arr.splice(i, 0, ','); //添加逗号
                                num = 1;
                                i--;
                            }
                        }
                        return val_arr.join('');
                    }
                },
                /* 价格转换 */
                toPrice: function(value) {
                    return value ? parseInt(value) / 100 : '0';
                },
                f_status: function(status) {
                    if (Number(status) == -1) return '全部状态';
                    let arr = ['待付款', '待发货', '待收货', '已完成', '售后中', '已关闭', '售后完成', '已取消', '待审核', '审核失败', '待填运费'];
                    return arr[Number(status)];
                },
                levelName: function(val) {
                    // let txts = ['普通用户', '会员', 'VIP会员', '区域经销商', '总经销商', '特约经销商', '合伙人', '高级合伙人', '董事', '高级董事', '战略董事', '联合创始人'];
                    let txts = ['普通用户', '会员', 'VIP', '区域经销商', '代理', '特约经销商', '合伙人', '高级合伙人', '董事', '高级董事', '战略董事', '联合创始人'];
                    return txts[val];
                },
                // 小数转化
                decimal: function(value) {
                    if (!value) return '';
                    let text = value ? (parseInt(value) / 100).toFixed(2) : '.00';
                    return text.substring(text.indexOf('.'), text.indexOf('.') + 3) == '.00' ? '.00' : text.substring(text.indexOf('.'), text.indexOf('.') + 3);
                }
            }
        });
    },
    mounted() {
        let that = this;
        if (app.device().ios && !app.isWeChat()) {
            that.top_show = true;
        }

        that.$nextTick(function() {
            setTimeout(function() {
                //如果是ios
                if (app.device().ios && app.isWeChat() && that.is_wxjs) {
                    app.wechatjs.config = false;
                    app.wechatjs.share_config = {
                        share_title: '悦小妖商城',
                        share_img: location.origin + '/static/images/mainproduct.png?123',
                        share_url: tools.cache.get('initUrl'),
                        share_desc: '全生命周期的健康管理',
                        is_specific: false
                    };
                    app.wechatjs.run({ api_url: '/api/wechat/js' });
                }

                const loginData = JSON.parse(tools.cache.get('loginData'));

                that.is_dealer = loginData.is_dealer;
                that.img_path = loginData.mp_qrcode;
                that.is_subscribe = loginData.is_subscribe;
                // that.show_prop = res.data.is_address === 0;
                // 实名认证判断
                if (loginData.is_withdraw == 0 || loginData.is_perfect != 1) {
                    if (Number(loginData.level_id) >= 2) {
                        if (!tools.cache.get('has_tips')) {
                            tools.cache.set('has_tips', 1);
                            tools.alert.ui.messageBox.confirm('您尚未完善实名信息，去完善?').then(action => {
                                tools.router.push({ path: '/distribution/improveidentity' });
                            }).catch(error => {
                                // that.authentication(option);
                            });
                        }
                    }
                }
            }, 500);
            $('body').on('touchstart', '[m="click"]', function(e) {
                var e = e || window.event;
                $(this).addClass('click-active');
            });
            $('body').on('touchmove', '[m="click"]', function(e) {
                var e = e || window.event;
                $(this).removeClass('click-active');
            });
            $('body').on('touchend', '[m="click"]', function(e) {
                var e = e || window.event;
                $(this).removeClass('click-active');
            });
        });
    },
    provide: function() {
        return { top_show: this.top_show };
    },
    name: 'app',
    watch: {
        // 如果路由有变化，会再次执行该方法
        // $route: "isLinkChange",
        $route(val) {
            let that = this;
            that.isLinkChange(val);
            // 需要显示手机导航栏的返回按钮
            if (this.$route.path == '/distribution/index' || this.$route.path == '/distribution/retail' || this.$route.path == '/distribution/personal/index' || this.$route.path == '/retail/personal/index') {
                that.top_isback = false;
            } else {
                that.top_isback = true;
            }

            // 需要显示手机导航栏的分享按钮
            if (this.$route.path == '/distribution/help/details' || this.$route.path == '/retail/info/details') {
                that.rightBtn = true;
            } else {
                that.rightBtn = false;
            }

            if (val.path == '/distribution/improveidentity' || val.path == '/address' || val.path == '/login' || val.path == '/register_audit') {
                this.show_prop = false;
            } else {
                // that.show_prop = Number(tools.cache.get('is_address')) === 0;
            }

            if (val.path == '/tourists/course/qrcode' || val.path == '/register' || val.path == '/tourists/course/detail' || val.path == '/distribution/examination/index' || val.path == '/distribution/examination/train_list' || val.path == '/distribution/examination/notice' || val.path == '/distribution/examination/list' || val.path.indexOf('/college') >= 0 || val.path == '/distribution/examination/result') {
                that.show_kefu = false;
            } else {
                that.show_kefu = true;
            }

            if (val.path == '/tourists/course/detail') {
                that.top_show = true;
            } else {
                that.top_show = (app.device().ios && !app.isWeChat()) || false;
            }
        }
    },
    methods: {
        // 实现移动端拖拽
        down() {
            this.flags = true;
            this.touchOrClick = true;
            let touch;
            if (event.touches) {
                touch = event.touches[0];
            } else {
                touch = event;
            }
            this.position.x = touch.clientX;
            this.position.y = touch.clientY;
            this.dx = moveDiv.offsetLeft;
            this.dy = moveDiv.offsetTop;
        },
        move() {
            this.touchOrClick = false;
            if (this.flags) {
                let touch;
                if (event.touches) {
                    touch = event.touches[0];
                } else {
                    touch = event;
                }
                this.nx = touch.clientX - this.position.x;
                this.ny = touch.clientY - this.position.y;
                this.xPum = this.dx + this.nx;
                this.yPum = this.dy + this.ny;
                //添加限制：只允许在屏幕内拖动
                const maxWidth = document.body.clientWidth - 54; //屏幕宽度减去悬浮框宽高
                const maxHeight = document.body.clientHeight - 54;
                if (this.xPum < 0) {
                    //屏幕x限制
                    this.xPum = 0;
                } else if (this.xPum > maxWidth) {
                    this.xPum = maxWidth;
                }
                if (this.yPum < 0) {
                    //屏幕y限制
                    this.yPum = 0;
                } else if (this.yPum > maxHeight) {
                    this.yPum = maxHeight;
                }
                moveDiv.style.left = this.xPum + 'px';
                moveDiv.style.bottom = maxHeight - this.yPum + 'px';
            }
        },
        //鼠标释放时候的函数
        end() {
            this.flags = false;
            if (this.touchOrClick) {
                this.toKefu();
            }
        },
        toInfo() {
            this.show_alert = false;
            this.toUrl('/distribution/improveidentity', { type: this.types });
        },
        toAddress() {
            this.show_prop = false;
            this.toUrl('/address');
        },
        showLoading() {
            var that = this;

            console.log('改变了导航:', this.$route);
            that.is_dealer = tools.cache.get('isDealer');
            that.is_subscribe = 1;
            that.img_path = tools.cache.get('mpQrcode');
        },
        showQRcode() {
            var _this = this;
            _this.wrap = !_this.wrap;
        },
        toKefu() {
            /* var that = this;
            if (that.kefu.type == 1) {
                that.toUrl('/distribution/chat', {
                    goods_id: that.kefu.id
                });
            } else if (that.kefu.type == 2) {
                that.toUrl('/distribution/chat', {
                    order_id: that.kefu.id
                });
            } else {
                that.toUrl('/distribution/chat');
            } */
            location.href = 'https://work.weixin.qq.com/kfid/kfc21415a36b81e83dc';
        },
        isShowPopup(to) {
            let that = this;
            let loginData = tools.cache.get('loginData');
            if (loginData) {
                let data = JSON.parse(loginData);
                if (data.is_perfect != 1 && to.path !== '/distribution/improveidentity' && to.path !== '/login' && to.path !== '/register') {
                    that.show_alert = true;
                }
            }
        },
        isLinkChange(to) {
            let that = this;
            that.is_dealer = tools.cache.get('isDealer');
            that.is_subscribe = 1;
            that.img_path = tools.cache.get('mpQrcode');

            //微信分享
            that.$nextTick(function() {
                setTimeout(function() {
                    //ios
                    if (app.device().ios && app.isWeChat() && that.is_wxjs) {
                        app.wechatjs.ready({
                            share_title: '悦小妖商城',
                            share_img: location.origin + '/static/images/mainproduct.png?123',
                            share_url: tools.cache.get('originUrl'),
                            share_desc: '全生命周期的健康管理',
                            is_specific: false
                        });
                    }
                    //安卓
                    if (!app.device().ios && app.isWeChat() && that.is_wxjs) {
                        //判断是否为微信
                        app.wechatjs.config = false;
                        app.wechatjs.share_config = {
                            share_title: '悦小妖商城',
                            share_img: location.origin + '/static/images/mainproduct.png?123',
                            share_url: location.href,
                            share_desc: '全生命周期的健康管理',
                            is_specific: false
                        };
                        app.wechatjs.run({ api_url: '/api/wechat/js' });
                    }

                    if (tools.cache.get('isLogin') == 1) {
                        // that.getTempActivity();
                    }
                }, 500);
            });
        },
        /* 获取是否登录 */
        isLogin(url) {
            var that = this;
            // console.log("获取是否登录=========");
            //debugger
            tools.ajax({
                url: url,
                ajaxData: {},
                successFun: function(res) {
                    tools.cache.set('loginData', JSON.stringify(res.data));
                    tools.cache.set('isUser', res.data.is_user);
                    tools.cache.set('isDealer', res.data.is_dealer);
                    localStorage.isDealer = res.data.is_dealer;

                    tools.cache.set('isSubscribe', res.data.is_subscribe);
                    tools.cache.set('mpQrcode', res.data.mp_qrcode);
                    tools.cache.set('parent', res.data.parent);
                    tools.cache.set('openid', res.data.openid);
                    tools.cache.set('is_address', res.data.is_address);


                },
                errorFun: function(error) {
                    log.error('登录失败!');
                    tools.alert.error('登录失败!');
                    tools.cache.set('isLogin', 0);
                    tools.cache.set('isAuth', 0);
                },
                type: 'GET'
            });
        },
        /* 跳转 */
        toUrl(url, val) {
            tools.router.push({
                path: url,
                query: val
            });
        },
        fun(res) {
            this.nationCode = res;
        },
        /*领取优惠券*/
        getCoupon() {
            let that = this;
            tools.alert.loading();
            tools.ajax({
                url: '/api/coupons/give',
                successFun: function(res) {
                    if (res) {
                        tools.alert.closeLoading();
                        that.toUrl('/distribution/coupon/list');
                    }
                },
                errorFun: function(error_data, status, headers, error_obj) {
                    tools.alert.closeLoading();
                    tools.alert.message(error_data.error_msg);
                },
                type: 'POST'
            });
        },
        /*领取优惠券*/
        getCouponLists() {
            let that = this;
            tools.alert.loading();
            tools.ajax({
                url: '/api/coupons/take',
                successFun: function(res) {
                    if (res) {
                        tools.alert.closeLoading();
                        that.couponLists = res.list;
                    }
                },
                errorFun: function(error_data, status, headers, error_obj) {
                    tools.alert.closeLoading();
                    tools.alert.message(error_data.error_msg);
                },
                type: 'GET'
            });
        },
        goPath(path, query) {
            this.showAugActivity = false;
            this.toUrl(path, query);
        },
        /* 获取临时活动 */
        getTempActivity() {
            const that = this;

            tools.ajax({
                url: '/api/temp/activity',
                ajaxData: {},
                type: 'GET',
                successFun: (res) => {
                    that.showAugActivity = res.data.activity202108_show > 0 || res.data.activity202109_voucher > 0;
                    that.showReplenishment = res.data.activity202108_show > 0 && res.data.activity202109_voucher == 0;
                    that.showUnusedVoucher = res.data.activity202109_voucher > 0;
                    that.voucherAmount = res.data.activity202109_voucher;
                    that.voucherStartAt = res.data.activity202109_voucher_start;
                    that.voucherEndAt = res.data.activity202109_voucher_end;
                },
                errorFun: (error_data, status, headers, error_obj) => {
                    tools.alert.closeLoading();
                    tools.alert.error(error_data.error_msg);
                }
            });
        },
        /* 获取弹窗状态 */
        getDialogVisiable() {
            const that = this;

            tools.ajax({
                url: '/api/user/supplier/unup',
                ajaxData: {},
                type: 'GET',
                isLoading: false,
                successFun: (resp) => {
                    if (resp.data.status && location.pathname !== '/distribution/distributionorder/list') {
                        tools.alert.confirm(resp.data.msg, () => {
                            that.toUrl('/distribution/distributionorder/list', { order_status: '0' });
                        });
                    }
                },
                errorFun: (error_data, status, headers, error_obj) => {
                    tools.alert.closeLoading();
                    tools.alert.error(error_data.error_msg);
                }
            });
        }
    },
    components: { topFixed, jdCity, Popup },
    filters: {
        /* 价格转换--保留两位小数 */
        toFixedPrice: function(value) {
            return value ? (parseInt(value) / 100).toFixed(2) : '0';
        },
        /* 自定时间格式转换 */
        setTimeTran: function(value, type) {
            return parseInt(value) === 0 ? '-' : tools.date(type, value);
        }
    }
};
</script>

<style lang="scss">
@import "~assets/sass/tool.scss";
@import "~components/city/ydui.css";
.pt88 {
    padding-top: r(88px);
}

.top88 {
    top: r(88px) !important;
}

.base-props-box {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;

    .props {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0; // width: 100%;
        // height: 100%;
        background: #000000;
        opacity: 0.7;
        z-index: 101;
    }

    .alert-a {
        width: r(554px);
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        z-index: 101;

        .close-btn {
            text-align: center;
            margin-top: r(44px);
            font-size: r(70px);
            color: #ffffff;
        }

        .middle-center {
            position: relative;
            width: 100%; // height: pxTorem(676px/2);
            background-color: #fff;
            border-radius: r(15px);
            padding: r(30px);
            font-size: r(28px);

            p {
                margin-bottom: r(10px);
            }

            .div-btns {
                padding-top: r(10px);
                text-align: right;

                a {
                    margin-right: r(20px);

                    &:last-child {
                        color: rgb(54, 54, 233);
                    }
                }
            }

            // background-position: center;
            // background-size: cover;
            // padding-top: pxTorem(42px);
            .middel-top {
                width: r(403px);
                margin: 0 auto;
                text-align: center;
                font-size: r(34px);
                color: #60605f;
                letter-spacing: 0;
                padding-top: r(227px);
            }

            .middel-text {
                text-align: center;
                margin-top: r(45px);
                font-size: r(64px);
                color: #ff9d4a;
                letter-spacing: r(4.81px);

                span {
                    font-size: r(48px);
                }
            }

            .middel-bottom {
                width: r(470px);
                height: r(80px);
                text-align: center;
                line-height: r(84px);
                background: #ea9045;
                border-radius: r(8px);
                font-size: r(34px);
                color: #ffffff;
                letter-spacing: 0;
                position: absolute;
                bottom: r(42px);
                left: r(42px);
            }
        }
    }
}

.h-navi {
    width: pxTorem(50px);
    position: fixed;
    right: pxTorem(12px);
    bottom: pxTorem(73px); // top: pxTorem(500px);
    z-index: 999;

    .m-size {
        background-repeat: no-repeat;
        background-size: cover;
        background-position: 0 0;
        display: block;
        clear: both;
        width: pxTorem(50px);
        height: pxTorem(50px);
        border-radius: pxTorem(5px);
        margin-bottom: pxTorem(10px);

        &:last-child {
            margin-bottom: 0;
        }
    }

    .h-cart {
        background-image: url("/static/images/hover_cart@3x.png");
    }

    .h-service {
        background-image: url("/static/images/hover_service@3x.png");
    }

    .h-center {
        background-image: url("/static/images/hover_center@3x.png");
    }
}

#app {
    font-family: big5, PingFangSC-Regular, "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* color: #2c3e50; */
    // color: #fff;
    /* background-color: #fff; */
    min-height: 100%;
}

.none-subscribe {
    padding-top: pxTorem(40px);

    &[i="distribution-personal-index"] {
        padding-top: pxTorem(40px) !important;

        .top {
            //   margin-top: pxTorem(40px)!important;
            //   height: pxTorem(300px);
        }
    }

    &[i="retail-personal-index"] {
        padding-top: pxTorem(40px) !important;

        .top {
            //   padding-top: pxTorem(55px);
            //   height: pxTorem(165px);
        }
    }

    &[i="distribution-stock-list"] {
        .fixed {
            //   top: pxTorem(40px);
            padding-top: pxTorem(40px);
        }

        // padding-top: pxTorem(95px);
    }

    &[i="distribution_register"] {
        padding-top: 0;

        .register {
            padding-top: pxTorem(55px); //height: pxTorem(165px);
        }
    }

    &[i="index"] {
        padding-top: pxTorem(40px) !important;

        .index-header {
            height: pxTorem(155px);
            padding-top: pxTorem(65px);
        }
    }

    &[i="loose-warp"] {
        padding-top: 0;
    }
}

.QR-code {
    width: pxTorem(295px);
    background: #fff;
    height: pxTorem(340px);
    border-radius: pxTorem(8px);
    position: relative;
    top: 50%;
    left: 50%;
    z-index: 100;
    text-align: center;
    margin-top: pxTorem(-170px);
    margin-left: pxTorem(-147.5px);

    h1 {
        color: #545454;
        font-size: pxTorem(14px);
        font-weight: normal;
        height: pxTorem(64px);
        line-height: pxTorem(64px);

        span {
            font-size: pxTorem(18px);
            font-weight: 600;
            color: #286acb;
            display: inline-block;
            margin-right: pxTorem(5px);
        }
    }

    img {
        width: pxTorem(215px);
        height: pxTorem(215px);
        margin: 0 auto;
    }

    p {
        font-size: pxTorem(18px);
        margin-top: pxTorem(20px);
        height: pxTorem(20px);
        line-height: pxTorem(20px);
        color: #9b9b9b;
    }

    i {
        position: absolute;
        height: pxTorem(40px);
        box-sizing: content-box;
        padding: pxTorem(10px) 0 0 pxTorem(10px);
        width: pxTorem(34px);
        font-size: pxTorem(34px);
        color: #9b9b9b;
        right: 0;
        top: pxTorem(-48px);
    }
}

.coupon {
    position: relative;

    .mask {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.5);
        z-index: 1;
    }

    .cou-box {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-75%);
        height: r(450px);
        width: r(658px);
        background: url("~images/coupon-top.png");
        background-size: cover;
        background-repeat: no-repeat;
        background-position-x: r(-16px);
        z-index: 2;
        padding-top: r(106px);

        .coupon-item {
            width: r(500px);
            height: r(150px);
            margin: 0 auto;
            margin-bottom: r(16px);
            padding: r(28px) 0 r(26px) r(43px);
            display: flex; // background: #FFFFFF;
            background: url("~images/coupon-bg.png");
            background-size: contain;
            background-repeat: no-repeat;
            border-radius: r(6px);

            .item-left {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                font-size: r(28px);
                color: #b5241d;
                padding-right: r(25px);
            }

            .item-right {
                // border-left: r(1px) solid #979797;
                padding-left: r(21px);
                display: flex;
                align-items: center;
                font-size: r(28px);
                color: #64605f;
            }
        }

        .top {
            width: r(585px);
            height: r(310px);
            position: absolute;
            bottom: r(-230px);
            left: r(36px);
            background: url("~images/coupon-bottom.png");
            background-size: cover;
            background-repeat: no-repeat;

            .coupon-btn {
                position: absolute;
                bottom: r(51px);
                left: 50%;
                transform: translateX(-50%);
                width: r(322px);
                height: r(94px); // background-image: linear-gradient(-180deg, #F7DFB2 0%, #EDBB7B 100%);
                border-radius: r(42px);
                font-size: r(32px);
                color: #b5241d;
                line-height: r(94px);
                text-align: center;
            }
        }
    }
}

.mint-popup {
    border-radius: r(14px);
    .orderpop {
        width: r(550px);
        padding: r(40px) r(30px);
        border-radius: r(14px);
        h1 {
            font-size: r(30px);
            margin-bottom: r(25px);
        }
        .red-msg {
            color: #ea2323;
            margin-bottom: r(20px);
            margin-top: r(10px);
        }
        .goods-list {
            .goods {
                .goods-name {
                    font-size: r(26px);
                }
                .model-list {
                    padding-left: r(120px);
                    .model {
                        padding: r(8px) r(20px);
                        background-color: #ffffff;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        border: 1px solid #9f9f9f;
                        @include rounded(4px);
                        &:nth-of-type(1) {
                            margin-right: r(20px);
                        }
                        &.active {
                            background-color: #ff9d4a !important;
                            color: #ffffff;
                            border-radius: r(8px);
                            border: none;
                        }
                    }
                }
            }
        }
        .subActiOrder {
            display: block;
            width: r(250px);
            height: r(60px);
            background-color: #ff9d4a;
            color: #ffffff;
            font-weight: bold;
            margin: r(40px) auto 0;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
}

.augActivity {
    width: 100%;
    background-color: transparent !important;
    .close {
        @include WH(r(56px));
        background-image: url("~images/aug_activity/close.png");
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        margin: 15px auto 0;
    }
    .cont {
        .image {
            width: 100%;
            position: relative;
            img {
                width: 100%;
            }
            .btn {
                position: absolute;
                width: r(390px);
                height: r(98px);
                bottom: 0;
                left: 50%;
                transform: translateX(-50%);
            }
        }
    }
    .replenishment {
        width: 100%;
    }
    .voucher {
        width: r(586px);
        margin: 0 auto;
        .image {
            .amount {
                font-size: r(90px);
                font-weight: bold;
                color: #d81624;
                position: absolute;
                top: r(170px);
                left: 50%;
                transform: translateX(-50%);
                white-space: nowrap;
            }
            .btn {
                width: r(325px);
                height: r(87px);
                position: absolute;
                bottom: r(58px);
            }
        }
    }
    .unused_voucher {
        width: r(680px);
        margin: 0 auto;
        .image {
            .amount {
                width: r(358px);
                font-size: r(50px);
                color: #d81624;
                font-weight: bold;
                position: absolute;
                top: r(388px);
                left: r(250px);
                text-align: center;
            }
            .btn {
                width: r(150px);
                height: r(52px);
                top: r(454px);
                left: r(348px);
                transform: translateX(0);
            }
            .date {
                color: #ffffff;
                font-size: r(16px);
                font-weight: 300;
                position: absolute;
                left: r(156px);
                top: r(527px);
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// App.vue?05f7a160